import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from 'styled-components';

const CommunitySettingsSection = ({ title, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mb: 2,
        pb: 1.5,
        borderBottom: `1px solid ${theme?.border?.primary || '#eee'}`,
        '&:last-child': { borderBottom: 'none', mb: 0 }
      }}
    >
      <Typography
        sx={{
          fontSize: '13px',
          fontWeight: 600,
          color: theme?.text?.heading,
          mb: 1
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export default CommunitySettingsSection;
